import { Box, Typography } from '@mui/material'
import styles from './styles.module.css'

const SVGProfile = (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <circle cx="7" cy="7" r="7" fill="#D9D9D9" />
    </svg>
)


const maskUserId = (id) => {
    const str = String(id)
    if (str.length <= 2) return str
    return `${str[0]}**${str[str.length - 1]}`
}


function AllBet({ globalBets = [] }) {
  
    return (
        <>
            <Box className={styles.AllBetContainer}>

                <Typography className={styles.AllBetText}>
                    My Bets <br />
                    {globalBets.length}
                </Typography>

                <Box className={styles.LeaderBoardBox}>

                    {/* Head */}
                    <Box className={styles.HeaderBox}>
                        <Box className={styles.HeaderBoxInner}>
                            <Typography className={styles.HeadText1}>User</Typography>
                            <Typography className={styles.HeadText2}>Bet(INR)</Typography>
                        </Box>
                        <Typography className={styles.HeadText3}>X</Typography>
                        <Typography className={styles.HeadText3}>Cash out(INR)</Typography>
                    </Box>

                    {/* Body */}
                    <Box className={styles.BodyBox}>
                        {globalBets.length === 0 ? (
                            <Typography
                                sx={{
                                    textAlign: 'center',
                                    color: '#888',
                                    fontSize: '12px',
                                    mt: 2,
                                }}
                            >    
                            </Typography>
                        ) : (
                            globalBets.map((item, index) => (
                                <Box
                                    key={item.betId ?? index}
                                    className={item.x ? styles.GreenRow : styles.BlackRow}
                                >
                                    <Box className={styles.RowInnerBox}>
                                        {SVGProfile}
                                        <Typography className={styles.UserText}>
                                            {maskUserId(item.userId)}
                                        </Typography>
                                        <Typography className={styles.BetText}>
                                            {Number(item.stake).toFixed(2)}
                                        </Typography>
                                    </Box>

                                    {item.x && (
                                        <Typography className={styles.AmountText}>
                                            {item.x}
                                        </Typography>
                                    )}

                                    <Typography className={styles.AmountText}>
                                        {item.cashout != null ? Number(item.cashout).toFixed(2) : '0.00'}
                                    </Typography>
                                </Box>
                            ))
                        )}
                    </Box>

                </Box>
            </Box>
        </>
    )
}

export default AllBet